import { baseService } from './base-services'

/**
 * Playground stream transport (SER-6086): one authenticated POST replaces the
 * PubNub publish AND the SMS/WhatsApp seed endpoints — the backend
 * start-vs-continues on redis state, not on the entry endpoint.
 */

export interface PlaygroundMessageEnvelope {
  type: string
  content: object
}

interface RPlaygroundSendMessage {
  status: string
}

export interface RPlaygroundStatus {
  in_flight: boolean
  phlo_run_uuid: string | null
}

export const playgroundService = {
  // Lazy-open gate: asks the runner whether a run is in flight for this
  // (aom, phlo) before the event stream is opened, so an idle builder tab holds
  // no stream. Called imperatively from an effect, so no query key.
  getStatus: (aomUuid: string, phloUuid: string) =>
    baseService.get<RPlaygroundStatus>(`/v1/playground-stream/status/${aomUuid}/${phloUuid}`),

  // Run identity rides the body and is OPTIONAL: message #1 predates the run
  // channel (it only exists once PLAYGROUND_INITIATED arrives).
  sendMessage: (message: PlaygroundMessageEnvelope, runChannel?: string) =>
    baseService.post<RPlaygroundSendMessage>('/v1/playground-stream/message', {
      ...(runChannel && { channel: runChannel }),
      message,
    }),
}
